// extracted by mini-css-extract-plugin
module.exports = {"FeedBackBody":"feedBack_FeedBackBody__p8MNi","Title":"feedBack_Title__3fj7l","DoneButtonContainer":"feedBack_DoneButtonContainer__KHWxD","DoneButton":"feedBack_DoneButton__n-KTk"};